import memoizeOne from 'memoize-one';
import { combineExtensionProviders } from '@atlaskit/editor-common/extensions';
function prepareExtensionProvidersInternal(editorActions, extensionProviders) {
  if (!extensionProviders) {
    return;
  }
  if (typeof extensionProviders === 'function') {
    return combineExtensionProviders(extensionProviders(editorActions));
  }
  return combineExtensionProviders(extensionProviders);
}
var prepareExtensionProvider = function prepareExtensionProvider(getEditorActions) {
  return memoizeOne(function (extensionProviders) {
    return prepareExtensionProvidersInternal(getEditorActions(), extensionProviders);
  });
};
export default prepareExtensionProvider;